import Flickity from 'flickity';

const initTickers = (sections) => {
    sections.forEach((section) => {
        const tickerSpeed = 1;

        let flickity = null;

        const update = () => {
            if (flickity.slides) {
                flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
                flickity.selectedIndex = flickity.dragEndRestingSelect();
                flickity.updateSelectedSlide();
                flickity.settle(flickity.x);
            }
            window.requestAnimationFrame(update);
        };

        flickity = new Flickity(section, {
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
            wrapAround: true,
        });

        flickity.x = 0;

        update();
    });
};

export default initTickers;
